import { z } from 'zod';

const numberish = z.union([z.string(), z.number(), z.null()]).optional();

/**
 * 異動表單內的付款計畫（兩種採購單共用）。欄位格式在此檢查；
 * 合計／承接／總額變更必附等跨欄規則於提交前由 `validatePaymentPlanBeforeSubmit` 把關，後端最終驗證。
 */
export const paymentPlanFormSchema = z.object({
  enabled: z.boolean().optional(),
  inputMode: z.enum(['AMOUNT', 'PERCENTAGE']).optional(),
  changeReason: z.string().optional().nullable(),
  phases: z.array(z.object({
    phaseId: z.string().optional().nullable(),
    amount: numberish,
    percentage: numberish,
    dueDate: z.string().optional().nullable(),
  }).superRefine((phase, ctx) => {
    ['amount', 'percentage'].forEach((key) => {
      const raw = phase[key];
      if (raw === '' || raw == null) {
        return;
      }
      const n = Number(raw);
      if (!Number.isFinite(n) || n < 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: key === 'amount' ? '金額不可為負' : '百分比不可為負',
          path: [key],
        });
      }
    });
  })).optional(),
}).optional();

export const PAYMENT_PLAN_FIELD_LABELS = {
  paymentPlan: '付款計畫',
  'paymentPlan.changeReason': '計畫調整原因',
  'paymentPlan.phases': '付款期別',
  'paymentPlan.phases.amount': '期別金額',
  'paymentPlan.phases.percentage': '期別百分比',
  'paymentPlan.phases.dueDate': '到期日',
};
